import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "@phosphor-icons/react";

const STORAGE_KEY = "sendme_cookie_consent_v1";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      /* private mode or storage blocked — show banner anyway */
      setVisible(true);
    }
  }, []);

  const persist = (value) => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ value, at: Date.now() })); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      data-testid="cookie-consent"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50 border border-black bg-white shadow-[6px_6px_0px_#0A0A0B]"
    >
      <div className="p-5">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-9 h-9 grid place-items-center bg-[#FF3366]/10 text-[#FF3366] flex-shrink-0">
            <Cookie size={18} weight="duotone" />
          </div>
          <div className="flex-1">
            <div className="small-caps mb-1">Cookies & analytics</div>
            <p className="text-sm text-black/70 leading-relaxed">
              We use a small set of cookies to keep you signed in and a privacy-friendly analytics
              tool (Google Analytics 4) to understand which pages people read. We don't sell your
              data and we don't run third-party ad trackers other than what's required to serve
              Google AdSense on our blog. Read the{" "}
              <Link to="/privacy" className="underline">privacy policy</Link>.
            </p>
          </div>
          <button
            onClick={() => persist("dismissed")}
            aria-label="Dismiss"
            className="text-black/40 hover:text-black"
            data-testid="cookie-dismiss"
          >
            <X size={14} />
          </button>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 mt-4">
          <button
            onClick={() => persist("rejected")}
            className="btn-brut-ghost flex-1 !py-2"
            data-testid="cookie-reject"
          >
            Reject non-essential
          </button>
          <button
            onClick={() => persist("accepted")}
            className="btn-brut-primary flex-1 !py-2"
            data-testid="cookie-accept"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
